import {
  createExternalIdpLogin,
  listExternalIdentities,
  unlinkExternalIdentity,
  isLastSignInMethod,
  isNetworkFailure
} from './externalIdpLogin'

/**
 * Microsoft（Entra ID）ログインの画面側。
 *
 * 中身は {@link createExternalIdpLogin} と同じ。ここは<b>名前を付けて
 * いるだけ</b>で、通信の組み立ても判断も持たない。
 *
 * 提供元ごとに書き写すと、片方だけ直して片方が残る。実際にサーバ側で、
 * 提供元を1つしか見ていない繰り返しが見つかっている。
 */

const microsoft = createExternalIdpLogin('microsoft', 'microsoftLoginAvailable')

export function isMicrosoftLoginAvailable () {
  return microsoft.isAvailable()
}

export function startMicrosoftLogin () {
  return microsoft.startLogin()
}

export function startMicrosoftLink () {
  return microsoft.startLink()
}

/*
 * 一覧・解除・応答の読み分けは提供元で分かれない。ここから出しているのは、
 * 既に呼んでいる画面の書き換えを増やさないため。
 */
export {
  listExternalIdentities,
  unlinkExternalIdentity,
  isLastSignInMethod,
  isNetworkFailure
}
